var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',[_c('v-text-field',{attrs:{"type":"number","label":_vm.$t('amount'),"min":"0","filled":"","persistent-hint":"","hint":_vm.$t('addToGiftCardAmountInfo')},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }